var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"top"}},[_c('Alerts',{ref:"Alerts"}),_c('v-main',[_c('Navbar'),_c('router-view')],1),(!_vm.authenticated)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }